import React, { useEffect } from "react";
import heroImg from "../assets/about us.png";
import Image1 from "../assets/who we are.png";
import Image2 from "../assets/our mission.png";
import Image3 from "../assets/our vission.png";
import Image4 from "../assets/our values.png";



export default function About() {
  // Scroll animation
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.15 }
    );
    elements.forEach((el) => observer.observe(el));
  }, []);

  return (
    <>
      <style>{`
        /* HERO SECTION */
        .hero {
          position: relative;
          width: 100%;
          height: 50vh;
        }
        .hero img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: brightness(100%);
        }
        .hero-title {
          position: absolute;
          top: 50%;
          left: 10%;
          transform: translateY(-50%);
          color: white;
          font-size: 60px;
          font-weight: 700;
        }

        /* SECTION STYLING */
        .section {
          width: 80%;
          margin: 80px auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 40px;
        }
        .reverse { flex-direction: row-reverse; }

        /* IMAGE BOX WITH ATTRACTIVE SHAPE */
        .img-box {
          width: 260px;
          height: 260px;
          overflow: hidden;
          border-radius: 45% 55% 55% 45% / 50% 50% 50% 50%;
          flex-shrink: 0;
          box-shadow: 0 15px 25px rgba(0,0,0,0.2);
          transition: 0.5s ease;
        }
        .img-box img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        .img-box:hover img {
          transform: scale(1.15) rotate(5deg);
        }

        .text {
          flex: 1;
        }
        .text h2 {
          font-size: 32px;
          color: #1b7a9fff;
          margin-bottom: 15px;
        }
        .text p {
          font-size: 17px;
          color: #555;
          line-height: 1.7;
          text-align: justify;
        }

        /* RESPONSIVE STYLING */
        @media(max-width: 1024px) {
          .section { width: 90%; gap: 30px; }
          .img-box { width: 220px; height: 220px; }
          .text h2 { font-size: 28px; }
          .text p { font-size: 16px; }
        }
        @media(max-width: 768px){
          .section, .reverse { flex-direction: column; text-align: center; }
          .img-box { width: 200px; height: 200px; border-radius: 50%; margin: 0 auto; }
          .text { margin-top: 20px; }
          .text h2 { font-size: 24px; }
          .text p { font-size: 15px; }
        }
@media (max-width: 768px) {
  .hero {
    height: auto;
  }

  .hero img {
    height: auto;
    object-fit: contain;
  }
}

        /* SCROLL ANIMATION */
        .reveal {
          opacity: 0;
          transform: translateY(40px);
          transition: all 0.9s ease;
        }
        .reveal.active {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>

      {/* HERO SECTION */}
      <div className="hero reveal">
        <img src={heroImg} alt="About Hero" />
      
      </div>

      {/* SECTION 1: WHO WE ARE */}
      <div className="section reveal">
        <div className="img-box">
          <img
            src={Image1}
            alt="Who We Are"
          />
        </div>
        <div className="text">
          <h2>Who We Are</h2>
          <p>
            At Rapid Wash Laundry & Dry Cleaning Services, we pride ourselves on delivering exceptional quality and reliability in every aspect of our operations. With years of professional experience, our team has honed the skills necessary to provide the highest level of laundry, dry cleaning, and home cleaning services. We combine modern technology, eco-friendly products, and a deep understanding of fabric care to ensure that every garment and surface is treated with care and precision. Our commitment extends beyond cleaning; it encompasses the values of sustainability, customer satisfaction, and attention to detail. We strive to make every interaction with our clients seamless, from the initial consultation to the timely delivery of cleaned garments and homes. Every client, large or small, is treated with the same level of professionalism and dedication. By emphasizing transparency, trust, and exceptional service standards, we ensure that your experience with us is not just satisfactory but remarkable. From delicate fabrics to everyday laundry, we handle all tasks with precision, care, and dedication, turning mundane chores into a hassle-free experience for our customers.
          </p>
        </div>
      </div>
      

      {/* SECTION 2: OUR MISSION */}
      <div className="section reverse reveal">
        <div className="img-box">
          <img
            src={Image2}
            alt="Our Mission"
          />
        </div>
        <div className="text">
          <h2>Our Mission</h2>
          <p>
            Our mission is simple yet profound: to transform the way people experience cleaning services by combining efficiency, reliability, and sustainability. We believe that every garment, home, and workplace deserves careful attention, professional handling, and an eco-conscious approach. By leveraging cutting-edge technology, specialized equipment, and high-quality eco-friendly cleaning agents, we aim to deliver a service that exceeds expectations every single time. We are committed to creating long-lasting relationships with our customers, built on trust, transparency, and consistent results. Beyond cleaning, our goal is to provide convenience, reduce stress, and enhance the overall quality of life for our clients. Whether it’s a delicate silk dress, a high-maintenance carpet, or a busy household in need of comprehensive cleaning, our dedicated team applies meticulous care to every task. By focusing on efficiency, innovation, and sustainability, we ensure that our services not only meet immediate needs but also contribute positively to the environment and the community at large, making professional cleaning a delightful and seamless experience.
          </p>
        </div>
      </div>

      {/* SECTION 3: OUR VALUES */}
      <div className="section reveal">
        <div className="img-box">
          <img
            src={Image3}
            alt="Our Values"
          />
        </div>
        <div className="text">
          <h2>Our Values</h2>
          <p>
            At Rapid Wash aundry & Dry Cleaning Services, our values are the cornerstone of everything we do. We prioritize quality, integrity, and sustainability in every service we offer. Quality means delivering impeccable results consistently, ensuring that every garment, carpet, and home is treated with meticulous care. Integrity guides our actions, fostering transparency, honesty, and fairness in all interactions with clients, employees, and partners. Sustainability is at the heart of our operations, using environmentally responsible products and processes to minimize our ecological footprint while maintaining superior service standards. We also value innovation, continuously improving our methods, adopting new technologies, and staying ahead of industry trends to provide the most effective and convenient solutions. Client satisfaction is a top priority, and we measure success not just by the services rendered but by the smiles and trust of those we serve. These core values collectively define our approach, culture, and dedication, ensuring that every engagement with Rapid Wash aundry & Dry Cleaning Services reflects our commitment to excellence, professionalism, and care.
          </p>
        </div>
      </div>

      {/* SECTION 4: OUR VISION */}
      <div className="section reverse reveal">
        <div className="img-box">
          <img
            src={Image4}
            alt="Our Vision"
          />
        </div>
        <div className="text">
          <h2>Our Vision</h2>
          <p>
            Our vision at Rapid Wash aundry & Dry Cleaning Services is to become the most trusted and innovative cleaning solutions provider in the region, setting new standards for quality, convenience, and environmental responsibility. We aspire to revolutionize the industry by integrating technology, sustainability, and customer-centric practices that make professional cleaning accessible, reliable, and efficient for everyone. We envision a future where our services seamlessly blend with the lifestyles of our clients, providing them with more free time, less stress, and pristine spaces that reflect care and attention to detail. Beyond service delivery, we aim to build a brand synonymous with trust, transparency, and ethical practices, ensuring that both our clients and employees experience a supportive and professional environment. By continuously innovating, adopting eco-friendly practices, and maintaining unwavering commitment to excellence, we strive to inspire confidence in every interaction. Our long-term goal is to not only grow as a business but to contribute positively to communities, fostering awareness about sustainable practices and demonstrating how quality cleaning services can enhance daily life while protecting our planet for future generations.
          </p>
        </div>
      </div>
    </>
  );
}
